import * as React from 'react'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

interface PremiumPillProps {
  className?: string
  isPremium: boolean
}

export function PremiumPill({ className, isPremium }: PremiumPillProps) {
  if (isPremium) {
    return (
      <p
        className={cn(
          typographyVariants({ variant: 'body-sm' }),
          'srd:text-nowrap srd:bg-yellow-10 srd:text-yellow-100 srd:px-1.5 srd:py-0.5 srd:rounded-md',
          className,
        )}
      >
        Premium
      </p>
    )
  }

  return (
    <p
      className={cn(
        typographyVariants({ variant: 'body-sm' }),
        'srd:text-nowrap srd:bg-navy-10 srd:text-navy-50 srd:px-1.5 srd:py-0.5 srd:rounded-md',
        className,
      )}
    >
      Starter
    </p>
  )
}
